module.exports = __webpack_public_path__ + "media/images/icon-exclamation-f9b54ed5c72e1e9c3cb6f511b5e5fcf6.svg";